import Axios from "./Axios";

export default class OrderService extends Axios {
  finishOrder(order) {
    if (!order.visit) {
      order.visit = {};
    }
    if (!order.visit.card) {
      order.visit.card = {};
    }
    order.visit.card.number = localStorage.getItem("consumptionCard");
    return this.axios.post(`/order/pwa`, order);
  }
  finishOrderHits(order) {
    if (!order.visit) {
      order.visit = {};
    }
    if (!order.visit.card) {
      order.visit.card = {};
    }
    order.visit.card.number = localStorage.getItem("consumptionCard");
    return this.axios.post(`/order/hits-pwa`, order);
  }
  finishOrders(code, orders) {
    orders.forEach((order) => {
      if (!order.visit) {
        order.visit = {};
      }
      if (!order.visit.card) {
        order.visit.card = {};
      }
      order.visit.card.number = localStorage.getItem("consumptionCard");
    });

    return this.axios.post(`/orders/pwa`, orders);
  }
  finishOrdersOnlyDigital(orders) {
    return this.axios.post(`cardapio_digital/orders/pwa`, orders);
  }
  getConsumptionCard(number) {
    return this.axios.get(`/consumption-card/number/${number}`);
  }
  activeConsumptionCard(code, password) {
    return this.axios.post(`/consumption-card/${code}/active/visit`, password);
  }
  confirmConsumptionCard(code, password) {
    return this.axios.post(`/consumption-card/${code}/confirm/visit`, password);
  }
}
